// extracted by mini-css-extract-plugin
export var backgroundCoverCenter = "gen4Awards25-module--background-cover-center--3nCC7";
export var backgroundCoverTop = "gen4Awards25-module--background-cover-top--1jDPK";
export var backgroundContainTop = "gen4Awards25-module--background-contain-top--21cRP";
export var backgroundContainCenter = "gen4Awards25-module--background-contain-center--1D6TF";
export var backgroundContainLeft = "gen4Awards25-module--background-contain-left--a2RoZ";
export var awardsButton = "gen4Awards25-module--awardsButton--16iSl";
export var awards = "gen4Awards25-module--awards--3fFcN";
export var awardRow = "gen4Awards25-module--award-row--2pKmT";
export var doctorName = "gen4Awards25-module--doctor-name--1QTDS";
export var col3 = "gen4Awards25-module--col-3--6ArJF";
export var col9 = "gen4Awards25-module--col-9--11eyn";
export var awardsContainer = "gen4Awards25-module--awards-container--4Puy5";